// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/common/legacyScope.js#1 $
'use strict';

/** 
* @ngdoc service 
* @name tcApp.LegacyScopeService
* @description
* Legacy Scope Service adds legacy functions to $scope, emulating APIs for component script execution
*
*/
angular.module('tc.legacyScope', ['tc.global'])
.service('LegacyScopeService', function($log, $window, $route, $location, GlobalService, 
								LegacyScopeTweakService, LegacyScopeSearchService, TkLibService,
								WebsysLegacyScope, WebsysEditLegacyScope, WebsysListLegacyScope, WebsysListBoxesLegacyScope,
								WebsysDateTimeLegacyScope, WebsysCurrencyLegacyScope, WebsysHtmlRichTextLegacyScope) { 
	/* eslint no-unused-vars:0 */
	var $this = this;
	this.getDocument = function($scope) {
		var formName = 'f' + $scope.componentHtmlName;
		var formNameLegacy = 'f' + $scope.componentLegacyHtmlName;
		var tableName = 't' + $scope.componentHtmlName;
		var tableNameLegacy = 't' + $scope.componentLegacyHtmlName;
		// Get currency configuration from Global Service
		var currencyConfiguration = {
			decimalPlaces: 2,
			decimalSymbol: ',',
			groupingSymbol: '.'
		};
		if (angular.isDefined(GlobalService.configuration.currency)) {
			currencyConfiguration = GlobalService.configuration.currency;
		}
		this.currencyConfiguration = currencyConfiguration;
		
		var formObjectDefinition = {
			get: function() {
				var formItems = {};
				angular.forEach($scope.data.items, function(item, itemName) {
					// Define the form elements using accessor functions so the current value is always retrieved
					Object.defineProperty(formItems, itemName, {
						get: function() {
							return LegacyScopeSearchService.getItemFromDataObject($scope, itemName, true);
						}
					});
				});

				// Append table items
				if (angular.isDefined($scope.data.listRows)) {
					angular.forEach($scope.data.listRows, function(listRow, listRowIndex) {
						angular.forEach(listRow, function(item, itemName) {
							if ((itemName.substr(0, 2) !== '$$') && (itemName.substr(0, 1) !== '_')) {
								var tableItemName = (itemName + 'z' + (listRowIndex + 1));
								Object.defineProperty(formItems, tableItemName, {
									get: function() {
										return LegacyScopeSearchService.getItemFromDataObject($scope, tableItemName, false);
									}
								});
							}
						});
					});
				}

				angular.extend(formItems, {elements: formItems, id: formNameLegacy});
				
				formItems.getElementsByTagName = function() {
					$log.warn('Call to form.getELementsByTagName not supported');
					return [];
				};
				
				return formItems;
			}
		};
		
		// Emulates document/element.getElementsByTagName
		// Returns items based on tagName property.
		// Also called by legacyScope/websysList
		var getElementsByTagName = function(data, tagName, tableItemsOnly, listRowIndex) {
			if (!data) return [];
			var elements = [];
			if ((!tableItemsOnly) && (data.items)) {
				for (var i in data.items) {
					if (i === 'elements') continue;

					if ((data.items[i].tagName) &&
					(data.items[i].tagName.toUpperCase() == tagName.toUpperCase())) {
						elements.push(data.items[i]);
					}
				}
			}
			if (data.listRows) {
				for (var rowIndex = 0; rowIndex < data.listRows.length; rowIndex++) {
					if ((angular.isDefined(listRowIndex)) && (listRowIndex !== rowIndex)) continue;
					
					angular.forEach(data.listRows[rowIndex], function(item, key) {
						if (!LegacyScopeTweakService.isListRowMetaData(key)) {
							elements.push(item);
						}
					});
				}
			}
			return elements;
		};
		$this.getElementsByTagName = getElementsByTagName;

		// Emulates an HTML table object based on list row data
		var getTableObject = function() {
			var getListRowsObject = function() {
				var listRows = angular.copy($scope.data.listRows);
				angular.forEach(listRows, function(listRow, listRowIndex) {
					var listCells = [];
					angular.forEach(listRow, function(item, itemName) {
						if (!LegacyScopeTweakService.isListRowMetaData(itemName)) {
							listCells.push(item);
						}
					});
					listRow._listRowIndex = listRowIndex;
					listRow.rowIndex = listRowIndex;
					listRow.sectionRowIndex = listRowIndex;
					listRow.TRAKListIndex = listRowIndex;
					listRow.id = '';
					listRow.getElementsByTagName = function getRowElementsByTagName(tagName) {
						return getElementsByTagName($scope.data, tagName, true, listRowIndex);
					};
					listRow.cells = listCells;
				});
				return listRows;
			};
			
			var tableObject = {
				id: tableNameLegacy,
				name: tableNameLegacy,
				tagName: 'TABLE',
				tBodies: [{}],
				getElementsByTagName: function getTableElementsByTagName(tagName) {
					return getElementsByTagName($scope.data, tagName, true);
				}
			};
			// Define the table row elements using accessor functions so the current value is always retrieved
			Object.defineProperty(tableObject, 'rows', {
				get: getListRowsObject
			});
			Object.defineProperty(tableObject.tBodies[0], 'rows', {
				get: getListRowsObject
			});
			return tableObject;
		};

		var documentObject = {
			getElementById: function(id) {
				if (!id) return;
				if ((id === formNameLegacy) || (id === formName)) return this.forms[formNameLegacy];
				if ((id === tableNameLegacy) || (id === tableName)) {
					return getTableObject();
				}
				return LegacyScopeSearchService.getItemFromDataObject($scope, id, true);
			},
			getElementsByTagName: function(tagName) {
				return getElementsByTagName($scope.data, tagName);
			},
			getElementsByName: function(name) {
				var elements = [];
				// Check for items with this name
				if ($scope.data && $scope.data.items && $scope.data.items[name]) {
					elements.push($scope.data.items[name]);
				}

				return elements;
			},
			getElementsByClassName: function(classNames) {
				$log.warn('Call to document.getElementsByClassName', classNames);
				return [];
			},
			querySelector: function(selectors) {
				$log.warn('Call to document.querySelector with selectors:', selectors);
				return null;
			},
			querySelectorAll: function(selectors) {
				$log.warn('Call to document.querySelectorAll with selectors:', selectors);
				return [];
			},
			createElement: function() {
				$log.warn($scope.componentName, ': Call to document.createElement');
				return null;
			},
			createElementNS: function() {
				$log.warn($scope.componentName, ': Call to document.createElementNS');
				return null;
			},
			forms: {},
			f: {}
		};
		Object.defineProperty(documentObject.forms, formNameLegacy, formObjectDefinition);
		Object.defineProperty(documentObject.f, formNameLegacy, formObjectDefinition);
		Object.defineProperty(documentObject, formNameLegacy, formObjectDefinition);

		return documentObject;
	};

	this.windowObject = {
		location: {href: ''},
		frames: $window.frames,
		parent: $window.parent,
		document: $window.document,
		top: GlobalService.isHealthShareViewerEmbedded() ? $window : $window.top,
		window: $window.window,
		self: $window.self,
		navigator: $window.navigator,
		name: $window.name,
		focus: function() {},
		opener: $window.opener,
		innerHeight: $window.innerHeight,
		innerWidth: $window.innerWidth,
		outerHeight: $window.outerHeight,
		outerWidth: $window.outerWidth,
		setTimeout: function(arg) {
			if (angular.isFunction(arg)) arg();
			if (angular.isString(arg)) {
				var functionName = arg.split('(')[0];
				var argsString = arg.split('(')[1].split(')')[0];
				var argsArray = eval('[' + argsString + ']');
				GlobalService.callFunction('', functionName, argsArray);
			}
		},
		sessionStorage: $window.sessionStorage,
		localStorage: $window.localStorage,
		open: function(linkUrl, target) {
			$log.warn('Call to window.open not supported');
			return null;
		},
		close: function() {
			$location.url('/Back');
		}
	};

	this.getWindow = function($scope) {
		return this.windowObject;
	};
	
	// Returns 'session' object used by component scripts
	this.getSession = function(GlobalService) {
		var sessionData = {
			'CONTEXT': (((angular.isDefined($route.current))
						&& (angular.isDefined($route.current.params.CONTEXT)))
						? $route.current.params.CONTEXT : ''),
			'LOGON.USERID': GlobalService.logonData.userId,
			'LOGON.USERCODE': GlobalService.logonData.userCode,
			'LOGON.USERNAME': GlobalService.logonData.userName,
			'LOGON.GROUPID': GlobalService.logonData.groupId,
			'LOGON.GROUPDESC': GlobalService.logonData.groupDesc,
			'LOGON.PROFILEID': GlobalService.logonData.profileId,
			'LOGON.PROFILEDESC': GlobalService.logonData.profileDesc,
			'LOGON.HOSPID': GlobalService.logonData.hospId,
			'LOGON.HOSPDESC': GlobalService.logonData.hospDesc,
			'LOGON.TRUSTID': GlobalService.logonData.trustId,
			'LOGON.TRUSTDESC': GlobalService.logonData.trustDesc,
			'LOGON.SUBREGIONID': GlobalService.logonData.subRegionId,
			'LOGON.SUBREGIONDESC': GlobalService.logonData.subRegionDesc,
			'LOGON.REGION': GlobalService.logonData.region,
			'LOGON.CTLOCID': GlobalService.logonData.locId,
			'LOGON.CTLOCDESC': GlobalService.logonData.locDesc,
			'LOGON.SITECODE': GlobalService.logonData.siteCode,
			'LOGON.LANGID': GlobalService.logonData.langId,
			'SESSIONID': GlobalService.logonData.sessionId,
			'REMOTE_ADDR': GlobalService.logonData.remoteAddr,
			'XMONTHSSHORT': GlobalService.getGlobalStrings().XMONTHSSHORT
		};
		// Populate session object with SSO data if defined
		if (angular.isDefined(GlobalService.logonData.ssoData)) {
			angular.forEach(GlobalService.logonData.ssoData, function(ssoDataItem, ssoDataItemKey) {
				sessionData['LOGON.sso' + ssoDataItemKey] = ssoDataItem;
			});
		}
		return sessionData;
	};

	this.clearLocationRedirect = function() {
		this.windowObject.location = {href: ''};
	};

	this.getLocationRedirect = function() {
		if (this.windowObject.location && this.windowObject.location.href) return this.windowObject.location.href;
		if ((angular.isString(this.windowObject.location))
			&& (this.windowObject.location.toLowerCase().indexOf('http') !== 0)) {
			return this.windowObject.location;
		}
		return '';
	};

	this.tweakItems = LegacyScopeTweakService.tweakItems;
	this.tweakRowItemsFromRowOnward = LegacyScopeTweakService.tweakRowItemsFromRowOnward;

	this.getLegacyFunctions = function($scope) {
		var legacyFunctions = {};
		if (TkLibService.getTkLib) {
			legacyFunctions['tkLib'] = legacyFunctions['$'] = TkLibService.getTkLib($scope);
		}
		angular.extend(legacyFunctions, WebsysLegacyScope($scope, $this));
		angular.extend(legacyFunctions, WebsysEditLegacyScope($scope));
		angular.extend(legacyFunctions, WebsysListLegacyScope($scope, $this, legacyFunctions));
		angular.extend(legacyFunctions, WebsysListBoxesLegacyScope($scope));
		angular.extend(legacyFunctions, WebsysDateTimeLegacyScope($scope));
		angular.extend(legacyFunctions, WebsysCurrencyLegacyScope($scope));
		angular.extend(legacyFunctions, WebsysHtmlRichTextLegacyScope($scope));

		legacyFunctions[$scope.componentLegacyHtmlName + '_Reload'] = function(requestVariables, callbackFunction) {
			GlobalService.reloadComponent($scope.componentHtmlName, requestVariables, callbackFunction);
		};
		legacyFunctions['f' + $scope.componentLegacyHtmlName + '_submit'] = function() { return true; };
		return legacyFunctions;
	};

});
